import PropTypes from "prop-types";
import React, { Component } from "react";
import Overridable from "react-overridable";
import { Link } from "react-router-dom";

class LiteratureCover extends Component {
  getLabel = (isRestricted) =>
    isRestricted
      ? {
          corner: "left",
          color: "red",
          icon: "lock",
          title: "Restricted",
        }
      : null;

  handleMouseEnter = (e) => {
    const target = e.currentTarget;
    target.style.transform = "translateY(-2px)";
    target.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)";
    target.style.transition = "transform 0.2s ease, box-shadow 0.2s ease";
  };

  handleMouseLeave = (e) => {
    const target = e.currentTarget;
    target.style.transform = "translateY(0)";
    target.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
  };

  handleImageError = (e) => {
    e.target.style.display = "none";
  };

  getContainerStyle = (size, fixedSize) => {
    const baseStyle = {
      overflow: "hidden",
      borderRadius: "4px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      display: "inline-block",
      position: "relative",
      backgroundColor: "#f5f5f5", // Fallback background
    };

    if (fixedSize) {
      return {
        ...baseStyle,
        width: "120px",
        height: "160px",
        minWidth: "120px",
        minHeight: "160px",
        maxWidth: "120px",
        maxHeight: "160px",
      };
    }

    if (size === "small") {
      return {
        ...baseStyle,
        width: "140px",
        height: "200px",
        minWidth: "140px",
        minHeight: "200px",
        maxWidth: "140px",
        maxHeight: "200px",
        marginLeft: "29px",
      };
    }

    if (size === "medium") {
      return {
        ...baseStyle,
        width: "350px",
        height: "480px",
        minWidth: "350px",
        minHeight: "480px",
        maxWidth: "350px",
        maxHeight: "480px",
        marginLeft: "20px",
      };
    }

    if (size === "tiny") {
      return {
        ...baseStyle,
        width: "100px",
        height: "140px",
        minWidth: "100px",
        minHeight: "140px",
        maxWidth: "100px",
        maxHeight: "140px",
        borderRadius: "3px",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
      };
    }

    if (size === "super-tiny") {
      return {
        ...baseStyle,
        width: "60px",
        height: "80px",
        minWidth: "60px",
        minHeight: "80px",
        maxWidth: "60px",
        maxHeight: "80px",
        borderRadius: "2px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      };
    }

    if (size === "pending-loan") {
      return {
        ...baseStyle,
        width: "100px",
        height: "140px",
        minWidth: "100px",
        minHeight: "140px",
        maxWidth: "100px",
        maxHeight: "140px",
        borderRadius: "3px",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
        marginRight: "15px",
        alignSelf: "flex-start",
      };
    }

    return baseStyle;
  };

  getImageStyle = (size, fixedSize, isRestricted) => {
    return {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
      display: "block",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      opacity: isRestricted ? 0.6 : 1,
      cursor: isRestricted ? "not-allowed" : "pointer",
    };
  };

  getRestrictedLabelStyle = (size) => {
    // Adjust the restricted label size based on cover size
    if (size === "super-tiny") {
      return {
        position: "absolute",
        top: "2px",
        left: "2px",
        background: "red",
        color: "white",
        borderRadius: "2px",
        padding: "1px 3px",
        fontSize: "8px",
        fontWeight: "bold",
        zIndex: 2,
        lineHeight: "1",
      };
    }

    if (size === "medium") {
      return {
        position: "absolute",
        top: "15px",
        left: "15px",
        background: "red",
        color: "white",
        borderRadius: "6px",
        padding: "6px 15px",
        fontSize: "18px",
        fontWeight: "bold",
        zIndex: 2,
      };
    }

    return {
      position: "absolute",
      top: "5px",
      left: "5px",
      background: "red",
      color: "white",
      borderRadius: "3px",
      padding: "2px 6px",
      fontSize: "10px",
      fontWeight: "bold",
      zIndex: 2,
    };
  };

  renderImage = () => {
    const { isRestricted, linkTo, size, url, fixedSize } = this.props;

    // Use a regular img tag for better control
    const imageElement = (
      <img
        src={url}
        alt=""
        onError={this.handleImageError}
        style={this.getImageStyle(size, fixedSize, isRestricted)}
        {...(isRestricted ? { "aria-disabled": true } : {})}
      />
    );

    // If we need a link, wrap the image
    if (linkTo && !isRestricted) {
      return (
        <Link
          to={linkTo}
          style={{ display: "block", width: "100%", height: "100%" }}
        >
          {imageElement}
        </Link>
      );
    }

    return imageElement;
  };

  render() {
    const { size, url, isLoading, fixedSize } = this.props;

    if (isLoading || !url) return null;

    const containerStyle = this.getContainerStyle(size, fixedSize);
    const shouldHaveHover =
      fixedSize ||
      size === "small" ||
      size === "medium" ||
      size === "tiny" ||
      size === "super-tiny";

    return (
      <Overridable id="LiteratureCover.layout" {...this.props}>
        <div
          style={containerStyle}
          onMouseEnter={shouldHaveHover ? this.handleMouseEnter : undefined}
          onMouseLeave={shouldHaveHover ? this.handleMouseLeave : undefined}
        >
          {this.renderImage()}
          {this.props.isRestricted && (
            <div style={this.getRestrictedLabelStyle(size)}>🔒</div>
          )}
        </div>
      </Overridable>
    );
  }
}

LiteratureCover.propTypes = {
  asItem: PropTypes.bool,
  isRestricted: PropTypes.bool,
  linkTo: PropTypes.string,
  size: PropTypes.string,
  url: PropTypes.string,
  isLoading: PropTypes.bool,
  fixedSize: PropTypes.bool,
};

LiteratureCover.defaultProps = {
  asItem: false,
  isRestricted: false,
  linkTo: null,
  size: "large",
  url: null,
  isLoading: false,
  fixedSize: false,
};

export default Overridable.component("LiteratureCover", LiteratureCover);
